import { Props } from 'docz';
import { Playground } from '@playground';
import { Info } from "../../../../../packages/layout/src/components/info/info";
import * as React from 'react';
export default {
  Props,
  Playground,
  Info,
  React
};